import * as React from 'react'

import { LogoutComponent } from '../../components/OAuth2/Logout'

interface LogoutProps {}

export class Logout extends React.Component<LogoutProps, any> {
  render() {
    return <LogoutComponent />
  }
}
